function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "rotate(90 41.475 81.648)",
  fill: "#06c"
}, React.createElement("rect", {
  width: 14.28,
  height: 2.975,
  x: 31.832,
  y: 9.223,
  rx: 1.19
}), React.createElement("rect", {
  width: 59.797,
  height: 3.868,
  x: 8.33,
  y: 17.552,
  rx: 0.595
})), React.createElement("path", {
  d: "M70.64 48.79h44.79a5.95 5.95 0 015.95 5.95v47.303a5.95 5.95 0 01-5.95 5.95H34.212h0",
  stroke: "#06c",
  strokeWidth: 3.57,
  strokeLinecap: "round"
}), React.createElement("g", null, React.createElement("rect", {
  width: 58.905,
  height: 95.498,
  x: 1.636,
  y: 1.636,
  rx: 8.033,
  stroke: "#06c",
  strokeWidth: 3.272
}), React.createElement("rect", {
  width: 14.28,
  height: 2.975,
  x: 24.692,
  y: 9.52,
  rx: 1.19,
  fill: "#06c"
}), React.createElement("rect", {
  width: 57.417,
  height: 3.868,
  x: 2.975,
  y: 17.85,
  rx: 0.595,
  fill: "#06c"
}), React.createElement("rect", {
  width: 57.417,
  height: 3.868,
  x: 2.975,
  y: 77.35,
  rx: 0.595,
  fill: "#06c"
}), React.createElement("circle", {
  cx: 31.089,
  cy: 87.911,
  r: 2.529,
  fill: "#06c"
})), React.createElement("path", {
  d: "M70.822 16.014h-.003c0-.003-.002-.003-.002-.005a1.242 1.242 0 01-.242-.462c-.03-.097-.05-.2-.055-.304-.003-.04-.01-.075-.007-.116 0-.022-.005-.04-.005-.059.007-.123.032-.24.07-.352.002-.01.01-.02.015-.033.044-.122.11-.23.184-.33.012-.012.015-.032.028-.044l5.27-6.212c.405-.475 1.067-.484 1.48-.018.413.465.42 1.229.016 1.703l-2.842 3.35c4.152-.551 8.235.323 8.43.368 12.601 2.282 21.52 13.923 19.879 25.941-.08.597-.524 1.019-1.031 1.019-.055 0-.11-.005-.165-.012-.569-.105-.959-.721-.871-1.379 1.46-10.708-6.676-21.11-18.172-23.195-.052-.012-4.27-.916-8.242-.292l4.387 2.605c.515.304.714 1.03.45 1.622-.263.594-.894.824-1.409.522l-6.913-4.105a1.103 1.103 0 01-.25-.212",
  fill: "#06c"
}));

var SvgRotateDevice = function SvgRotateDevice(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 123.165,
    height: 109.778,
    viewBox: "0 0 123.165 109.778",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRotateDevice, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rotate-device.44c52791.svg";
export { ForwardRef as ReactComponent };